<template>
	<v-container style="height: 100vh; overflow: auto">
		<v-layout>
			<div>
				<v-card-title>{{ symbolsStore.GUILabel("88b38f3a-53cd-4f6d-b3b7-19a267c43185") }}</v-card-title>
				<v-card-subtitle v-if="domainStore.allDomains.length > 0">{{ subtitle }} </v-card-subtitle>
				<v-card-subtitle v-else>
					{{ symbolsStore.GUILabel("04cb3a90-3d52-4aab-bb57-c28d1d0793f5") }}
				</v-card-subtitle>
			</div>
			<v-spacer></v-spacer>
		</v-layout>

		<v-row class="mt-6">
			<transition-group name="list">
				<v-col v-for="domain in sortedDomains" :key="domain.id">
					<DomainCard :domain-id="domain.id" @click="clickDomain" />
				</v-col>
			</transition-group>
		</v-row>
	</v-container>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import router from "../router";
import DomainCard from "../components/DomainCard.vue";
import { useDomainStore } from "../store/domain";
import { useSymbolsStore } from "../store/symbols";

const domainStore = useDomainStore();
const symbolsStore = useSymbolsStore();

const subtitle = computed(() => {
	return symbolsStore.GUILabel("9537302b-5f6b-435b-9576-c8c559fd4894", {
		count: String(domainStore.allDomains.length),
		type: domainStore.allDomains.length == 1 ? "domain" : "domains",
	});
});
const sortedDomains = computed(() => {
	return domainStore.allDomains.toSorted((a, b) => a.name.localeCompare(b.name));
});

function clickDomain(id: string) {
	router.push(id);
}

onMounted(() => {
	domainStore.loadAllDomains();
});
</script>

<style scoped lang="scss">
.scrollable {
	overflow-y: auto !important;
}
.list-enter,
.list-leave-to,
.list-enter-active,
.list-leave-active,
.list-move {
	transition: transform 0.3s ease-in-out;
}
</style>
